import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
  userId: '',
  whiteList: [],
  brand: '',
  userRole: [],
  subscriptionId: null,
};

const fetchUserId = (state, action) => {
  return updateObject(state, { userId: action.userId });
};

const fetchWhiteList = (state, action) => {
  return updateObject(state, { whiteList: action.whiteList });
};

const fetchBrand = (state, action) => {
  return updateObject(state, { brand: action.brand });
};

const fetchUserRole = (state, action) => {
  return updateObject(state, { userRole: action.userRole });
};

const clearUserData = state => {
  return updateObject(state, {
    userId: '',
    whiteList: [],
    brand: '',
  });
};

const userData = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USERID:
      return fetchUserId(state, action);
    case actionTypes.FETCH_WHITELIST:
      return fetchWhiteList(state, action);
    case actionTypes.FETCH_BRAND:
      return fetchBrand(state, action);
    case actionTypes.FETCH_ROLE:
      return fetchUserRole(state, action);
    case actionTypes.AUTH_LOGOUT:
      return clearUserData(state);
    default:
      return state;
  }
};

export default userData;
